import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Container, Row, Col, Table, Button, Form, InputGroup, Card, Spinner, Alert, Badge } from "react-bootstrap";
import { toast } from "react-toastify";
import api from "../../../axiosConfig";

export default function GrupeList() {
  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const limit = 20;

  const navigate = useNavigate();

  const fetchList = async () => {
    setLoading(true);
    setError("");
    try {
      const res = await api.get("/contor/grupe", {
        params: {
          search: search.trim() || undefined,
          skip: (page - 1) * limit,
          limit: limit,
        },
      });
      setItems(res.data?.items || []);
      setTotal(res.data?.total || 0);
    } catch (e) {
      setError(e.response?.data?.detail || e.message || "Eroare la preluarea grupelor.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const t = setTimeout(fetchList, 300);
    return () => clearTimeout(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, search]);

  const handleDelete = async (id) => {
    if (!window.confirm("Sigur doriți să ștergeți această grupă de echipamente?")) {
      return;
    }
    try {
      await api.delete(`/contor/grupe/${id}`);
      toast.success("Grupa a fost ștearsă cu succes.");
      fetchList();
    } catch (e) {
      toast.error(e.response?.data?.detail || e.message || "Eroare la ștergerea grupei.");
    }
  };

  return (
    <Container fluid className="py-4">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <div>
          <h2 className="mb-1 text-dark fw-bold">Grupe Echipamente</h2>
          <p className="text-muted mb-0">Gestionarea claselor de echipamente și a pieselor compatibile</p>
        </div>
        <Button
          variant="dark"
          onClick={() => navigate("/contor/grupe/new")}
          className="shadow-sm px-4 py-2"
        >
          + Adaugă Grupă
        </Button>
      </div>

      <Card className="shadow-sm border-0 mb-4">
        <Card.Body className="p-3">
          <Form onSubmit={(e) => { e.preventDefault(); fetchList(); }}>
            <Row className="g-2">
              <Col xs={12} md={6}>
                <InputGroup>
                  <Form.Control
                    placeholder="Caută după cod sau descriere grupă..."
                    value={search}
                    onChange={(e) => { setSearch(e.target.value); setPage(1); }}
                  />
                  <Button variant="outline-secondary" type="submit">
                    Caută
                  </Button>
                </InputGroup>
              </Col>
              {search && (
                <Col xs={12} md={2}>
                  <Button
                    variant="outline-danger"
                    onClick={() => { setSearch(""); setPage(1); }}
                    className="w-100"
                  >
                    Resetează
                  </Button>
                </Col>
              )}
            </Row>
          </Form>
        </Card.Body>
      </Card>

      {error && <Alert variant="danger">{error}</Alert>}

      <Card className="shadow-sm border-0">
        <Card.Body className="p-0">
          <Table responsive hover className="align-middle mb-0">
            <thead className="table-light">
              <tr>
                <th style={{ width: "80px" }}>ID</th>
                <th>Cod</th>
                <th>Denumire/Descriere</th>
                <th>Piese Compatibile</th>
                <th style={{ width: "180px" }} className="text-end">Acțiuni</th>
              </tr>
            </thead>
            <tbody>
              {loading && items.length === 0 ? (
                <tr>
                  <td colSpan={5} className="text-center py-5">
                    <Spinner animation="border" className="me-2" />
                    Se încarcă...
                  </td>
                </tr>
              ) : items.length === 0 ? (
                <tr>
                  <td colSpan={5} className="text-muted text-center py-5">
                    Nu s-a găsit nicio grupă de echipamente.
                  </td>
                </tr>
              ) : (
                items.map((it) => (
                  <tr key={it.bxid}>
                    <td>#{it.bxid}</td>
                    <td className="fw-bold">{it.bxcod}</td>
                    <td>{it.bxdescr}</td>
                    <td>
                      {it.linii && it.linii.length > 0 ? (
                        <div className="d-flex flex-wrap gap-1">
                          {it.linii.map((l) => (
                            <Badge key={l.bxid} bg="secondary" className="fw-normal">
                              {l.part_code}
                            </Badge>
                          ))}
                        </div>
                      ) : (
                        <span className="text-muted small">Fără piese asociate</span>
                      )}
                    </td>
                    <td className="text-end">
                      <Button
                        variant="outline-primary"
                        size="sm"
                        className="me-2"
                        onClick={() => navigate(`/contor/grupe/edit/${it.bxid}`)}
                      >
                        Editează
                      </Button>
                      <Button
                        variant="outline-danger"
                        size="sm"
                        onClick={() => handleDelete(it.bxid)}
                      >
                        Șterge
                      </Button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </Table>
        </Card.Body>
      </Card>

      {total > limit && (
        <div className="d-flex justify-content-between align-items-center mt-3">
          <span className="text-muted small">Total: {total} grupe</span>
          <div className="d-flex gap-2">
            <Button
              variant="outline-secondary"
              size="sm"
              disabled={page === 1}
              onClick={() => setPage(page - 1)}
            >
              Anterior
            </Button>
            <span className="align-self-center px-2">Pagina {page}</span>
            <Button
              variant="outline-secondary"
              size="sm"
              disabled={page * limit >= total}
              onClick={() => setPage(page + 1)}
            >
              Următor
            </Button>
          </div>
        </div>
      )}
    </Container>
  );
}
